import useDialogStore from "@/store/useDialogStore";

type ResponseHandler<T = unknown> = (value: T | PromiseLike<T>) => void;
type DialogType = "alert" | "confirm" | "prompt";

interface DialogStore<T = unknown> {
    description: string;
    setDescription(description: string): void;
    type: DialogType;
    setType(state: DialogType): void;
    revealed: boolean;
    setRevealed: (show: boolean) => void;
    responseHandler?: ResponseHandler<T>;
    setResponseHandler(responseHandler: ResponseHandler<T>): void;
}

export default function useDialog() {
    const {
        setDescription,
        setRevealed,
        setType,
        setMessage,
        responseHandler,
        setResponseHandler,
    } = useDialogStore();

    const onInteractionEnd = (value: string | boolean) => {
        setRevealed(false);
        responseHandler?.(value);
        setDescription("");
        setMessage("")
    };

    const setAttributes = (type: DialogType, description: string, message: string = '') => {
        setRevealed(true);
        setDescription(description);
        setType(type);
        !!message && setMessage(message)
    };

    const confirm = (description = "", message: string = "") => {
        setAttributes("confirm", description, message);

        return new Promise<boolean>((res: any) => {
            setResponseHandler(res);
        });
    };

    const alert = (description = "", message: string = "") => {
        setAttributes("alert", description, message);

        return new Promise<boolean>((res: any) => {
            setResponseHandler(res);
        });
    };

    return {
        confirm,
        alert,
        onInteractionEnd,
    };
}